import { z } from "zod";

export const AddressSchema = z.object({
  region: z.string().min(2, "Region is required"),
  city: z.string().min(2, "City is required"),
  street: z.string().min(2, "Streets is required"),
  house_number: z.string().min(1, "House is required"),
  event_longitude: z.number().min(0, "Longitude is required"),
  event_latitude: z.number().min(0, "Latitude is required"),
})